import React from "react";

import Sesion from "../components/commons/sesion";
import Operation from "../components/operations/operation";

export default function Operations() {
  return (
    <div className={"Drawer"}>
      <Sesion screen={"Operations"} />
      <Operation />
    </div>
  );
}
